export default {
  light: 'light',
  dark: 'dark',
};
